import { useEffect } from 'react'

// Adds `is-visible` to every `[data-reveal]` element inside the root once it scrolls into view.
// Also watches for elements rendered later (e.g. after an async fetch).
const useReveal = (rootRef) => {
  useEffect(() => {
    const root = rootRef.current
    if (!root) return undefined
    const collect = () => root.querySelectorAll('[data-reveal]:not(.is-visible)')

    if (!('IntersectionObserver' in window)) {
      collect().forEach((el) => el.classList.add('is-visible'))
      return undefined
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    )
    const observeAll = () => collect().forEach((el) => observer.observe(el))
    observeAll()

    const mutations = new MutationObserver(observeAll)
    mutations.observe(root, { childList: true, subtree: true })

    return () => {
      observer.disconnect()
      mutations.disconnect()
    }
  }, [rootRef])
}

export default useReveal
